// Centralized application configuration.
// All configurable values should come from environment variables where possible.
// This file provides sane defaults matching the previous hard-coded behavior.

const env = process.env || {};

function toBool(value, defaultValue) {
  if (value === undefined) return defaultValue;
  const normalized = String(value).toLowerCase().trim();
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
  if (['false', '0', 'no', 'off'].includes(normalized)) return false;
  return defaultValue;
}

function toInt(value, defaultValue) {
  if (value === undefined) return defaultValue;
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? defaultValue : parsed;
}

// Backend base URL: single source of truth for CMS domain.
const defaultBackendUrl = 'https://cms.wolfsburgerlupe.de';
const rawBackendUrl = env.VUE_APP_BACKEND_URL || defaultBackendUrl;
// Normalize: strip trailing slashes so derived URLs don't get double slashes.
const normalizedBackendUrl = rawBackendUrl.replace(/\/+$/, '');

const appConfig = {
  appId: env.VUE_APP_APP_ID || '5',
  appName: env.VUE_APP_APP_NAME || 'Wolfsburger Lupe',
  institutionId: env.VUE_APP_INSTITUTION_ID || '1',
  ratgeberId: env.VUE_APP_RATGEBER_ID || '12',
  kitaId: env.VUE_APP_KITA_ID || '14',
  schulId: env.VUE_APP_SCHUL_ID || '15',
  offerId: env.VUE_APP_OFFER_ID || '2',
  city: env.VUE_APP_CITY || 'Wolfsburg',

  // Backend URLs derived from a single base URL
  backendUrl: normalizedBackendUrl,
  backendApiUrl: `${normalizedBackendUrl}/api/`,

  impressumContentId: toInt(env.VUE_APP_IMPRESSUM_CONTENT_ID, 233109),
  datenschutzContentId: toInt(env.VUE_APP_DATENSCHUTZ_CONTENT_ID, 233108),
  barrierefreiheitsContentId: toInt(env.VUE_APP_BARRIEREFREIHEIT_CONTENT_ID, 233110),

  shortDescriptionWordCount: toInt(env.VUE_APP_SHORT_DESCRIPTION_WORD_COUNT, 215),

  hideUserAccountRelatedFunctions: toBool(env.VUE_APP_HIDE_USER_ACCOUNT_FUNCTIONS, true),

  // External URLs for provider login, derived from the backend URL
  loginForProvidersUrl: `${normalizedBackendUrl}/#/`,
  loginForProvidersBaseUrl: normalizedBackendUrl,

  // Matomo analytics
  matomoHost: env.VUE_APP_MATOMO_HOST || 'https://webanalytik.stadt.wolfsburg.de/',
  matomoSiteId: toInt(env.VUE_APP_MATOMO_SITE_ID, 6),
};

export default appConfig;

